import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-letterboxd',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Letterboxd icon</title><path d="M8.29 16.752V7.2H6.546V4.8h6.328v2.4h-1.746v9.574h3.925v-2.618h2.839V19.2H6.545v-2.448h1.746zM0 12c0 6.628 5.372 12 12 12s12-5.372 12-12S18.628 0 12 0 0 5.372 0 12z"/></svg>`,
    styles: []
})
export class SimpleIconsLetterboxdComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#00D735';
    @Input() className: string = 'simple-icons-letterboxd'
    constructor() {}
    ngOnInit(): void {}
}
